import { DropdownList } from '@/components/Selector/Selector.styles';
import styled from 'styled-components';

export const TrackingCarrierSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  ${DropdownList} {
    position: relative;
  }
`;
